var render = function render(){var _vm=this,_c=_vm._self._c;return _c('car-approval-flow-core',{attrs:{"question-id":_vm.questionId,"node-width":_vm.nodeWidth,"node-height":_vm.nodeHeight,"level-gap":_vm.levelGap,"node-gap":_vm.nodeGap}})
}
var staticRenderFns = []

export { render, staticRenderFns }